import React from "react";

import * as Styled from "./encounters-history-report.styled";
import { useNavigate, useOutletContext } from "react-router-dom";
import { SingleDataTable } from "../../../layout/single-data-table/ui/single-data-table";
import { SectionSidebarNav } from "../../../shared/ui/section-sidebar-nav/section-sidebar-nav";

interface IPatientInfoOutletContext {
  setIsStretchContent: React.Dispatch<React.SetStateAction<boolean>>;
}

export const encounterHistoryItem = {
  encounterId: "292928",
  patientName: "Anna Cadence",
  patientNumber: "8901234",
  dateOfBirth: "01/01/1980",
  gender: "Female",
  encounterTime: "01/01/2024",
  encounterLocation: "BCHC Rehab Center",
  provider: "Testa, Nicholas",
  language: "English",
  ethnicity: "White",
  maritalStatus: "Married",
  stats: "The patient IS a 25 year old Female",

  healthEntity: {
    sections: [
      {
        id: "assessment-plan",
        title: "Assessment and Plan",
        tables: [
          {
            id: "assessment-plan-table",
            columns: [
              { key: "code", header: "Code" },
              { key: "description", header: "Description" },
              { key: "planType", header: "Plan Type" },
              { key: "dxStory", header: "Dx Story" },
              { key: "impression", header: "Impression" },
              { key: "planDescription", header: "Plan Description" },
            ],
            rows: [
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription: "UNATTENDED ELECTRICAL STIMULATION (97014)",
              },
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription: "THERAPEUTIC EXERCISE (97110)",
              },
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription:
                  "Rehab – Patient educated in correct exercise technique.",
              },
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription:
                  "Rehab – Patient educated in correct exercise technique.",
              },
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription:
                  "Rehab – Patient educated in correct exercise technique.",
              },
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription:
                  "Rehab – Patient educated in correct exercise technique.",
              },
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription:
                  "Rehab – Patient educated in correct exercise technique.",
              },
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription:
                  "Rehab – Patient educated in correct exercise technique.",
              },
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription:
                  "Rehab – Patient educated in correct exercise technique.",
              },
              {
                code: "724.2",
                description:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                planType: "CURRENT",
                dxStory: "—",
                impression: "—",
                planDescription:
                  "Rehab – Patient educated in correct exercise technique.",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },
      {
        id: "review-of-systems",
        title: "Review of Systems",
        tables: [
          {
            id: "review-of-systems-table",
            columns: [
              { key: "systemCategory", header: "System Category" },
              { key: "problem", header: "Problem" },
              { key: "indicator", header: "Indicator" },
            ],
            rows: [
              {
                systemCategory: "UNATTENDED ELECTRICAL STIMULATION (97014)",
                problem: "Final",
                indicator: "Reviewed",
              },
              {
                systemCategory: "THERAPEUTIC EXERCISE (97110)",
                problem: "Final",
                indicator: "Reviewed",
              },
              {
                systemCategory:
                  "Rehab - Patient educated in correct exercise technique.",
                problem: "Ordered",
                indicator: "Reviewed",
              },
              {
                systemCategory:
                  "Rehab - Patient educated in correct posture and body mechanics",
                problem: "Ordered",
                indicator: "Reviewed",
              },
              {
                systemCategory:
                  "Rehab - Patient educated in joint protection techniques",
                problem: "Ordered",
                indicator: "Reviewed",
              },
              {
                systemCategory:
                  "Rehab - Patient educated in edema reduction techniques.",
                problem: "Final",
                indicator: "Not Reviewed",
              },
              {
                systemCategory: "Rehab - follow up 2x/week",
                problem: "Final",
                indicator: "Not Reviewed",
              },
              {
                systemCategory: "Rehab - Continue HEP 2x/day",
                problem: "Ordered",
                indicator: "Not Reviewed",
              },
              {
                systemCategory:
                  "Rehab - Patient D/C to independent self-management.",
                problem: "Ordered",
                indicator: "Not Reviewed",
              },
              {
                systemCategory: "Rehab Outcome Expectations - met",
                problem: "Ordered",
                indicator: "Not Reviewed",
              },
              {
                systemCategory:
                  "Rehab Goal Attaiment - goals partially achieved",
                problem: "Ordered",
                indicator: "Not Reviewed",
              },
              {
                systemCategory:
                  "Rehab D/C Reasons - Goal attainment sufficient for D/C",
                problem: "Ordered",
                indicator: "Not Reviewed",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },
      {
        id: "vitals",
        title: "Vitals",
        tables: [
          {
            id: "vitals-table",
            columns: [
              { key: "date", header: "Date" },
              { key: "temp", header: "Temp" },
              { key: "pulse", header: "Pulse" },
              { key: "resp", header: "Resp" },
              { key: "pOx", header: "P.OX" },
              { key: "bp", header: "BP" },
              { key: "weight", header: "Weight" },
              { key: "height", header: "Height" },
              { key: "bmi", header: "BMI" },
            ],
            rows: [
              {
                date: "2024-01-01",
                temp: "98.6",
                pulse: "66 (Regular)",
                resp: "20 (Unlabored)",
                pOx: "95% (Room air)",
                bp: "112/74 (Sitting, Left Arm, Standard)",
                weight: "271.00 lbs",
                height: "66 in",
                bmi: "43.74 kg/m2",
              },
              {
                date: "2024-01-02",
                temp: "98.7",
                pulse: "68 (Regular)",
                resp: "22 (Unlabored)",
                pOx: "95% (Room air)",
                bp: "118/78 (Sitting, Left Arm, Standard)",
                weight: "152.00 lbs",
                height: "66 in",
                bmi: "45.20 kg/m2",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },
      {
        id: "physical-exam",
        title: "Physical Exam",
        tables: [
          {
            id: "physical-exam-table",
            columns: [
              { key: "examCategory", header: "Exam Category" },
              { key: "physicalExam", header: "Physical Exam" },
              { key: "result", header: "Result" },
            ],
            rows: [
              {
                examCategory: "Cardiovascular",
                physicalExam: "Cardiovascular examination reveals",
                result:
                  "normal heart sounds, regular rate and rhythm with no murmurs",
              },
              {
                examCategory: "Cardiovascular",
                physicalExam: "Examination of related systems reveals",
                result:
                  "eyes are clear, with no discharge, lesions or obvious infection of the conjunctivae or lids",
              },
              {
                examCategory: "Cardiovascular",
                physicalExam: "Examination of related systems reveals",
                result:
                  "respiratory effort is quiet, even and easy with no use of accessory muscles",
              },
              {
                examCategory: "Cardiovascular",
                physicalExam: "Examination of related systems reveals",
                result: "normal posture and body mechanics observed",
              },
              {
                examCategory: "Musculoskeletal",
                physicalExam: "Musculoskeletal examination reveals",
                result:
                  "full range of motion in all extremities, with no gross deformities, swelling or tenderness",
              },
              {
                examCategory: "Musculoskeletal",
                physicalExam: "Musculoskeletal examination reveals",
                result:
                  "normal strength and tone in all extremities, with no atrophy or fasciculations",
              },
              {
                examCategory: "Musculoskeletal",
                physicalExam: "Musculoskeletal examination reveals",
                result:
                  "normal gait and station observed, with no assistive devices used",
              },
              {
                examCategory: "Musculoskeletal",
                physicalExam: "Musculoskeletal examination reveals",
                result: "normal posture and body mechanics observed",
              },
              {
                examCategory: "Musculoskeletal",

                physicalExam: "Musculoskeletal examination reveals",
                result:
                  "full range of motion in all extremities, with no gross deformities, swelling or tenderness",
              },
              {
                examCategory: "Musculoskeletal",
                physicalExam: "Musculoskeletal examination reveals",
                result: "normal posture and body mechanics observed",
              },
              {
                examCategory: "Musculoskeletal",
                physicalExam: "Musculoskeletal examination reveals",
                result:
                  "full range of motion in all extremities, with no gross deformities, swelling or tenderness",
              },
              {
                examCategory: "Musculoskeletal",
                physicalExam: "Musculoskeletal examination reveals",
                result: "normal posture and body mechanics observed",
              },
              {
                examCategory: "Abdomen",
                physicalExam: "Abdominal examination reveals",
                result:
                  "abdomen is soft, non-distended and non-tender to palpation with no masses or organomegaly",
              },
              {
                examCategory: "Abdomen",
                physicalExam: "Abdominal examination reveals",
                result:
                  "abdomen is soft, non-distended and non-tender to palpation with no masses or organomegaly",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },
    ],
  },
};

export const EncountersHistoryReport = () => {
  const navigate = useNavigate();
  const outletContext = useOutletContext<
    IPatientInfoOutletContext | undefined
  >();
  const setIsStretchContent = outletContext?.setIsStretchContent;
  const contentScrollerRef = React.useRef<HTMLDivElement | null>(null);
  const navigationSections = React.useMemo(
    () => [
      { id: "report-details", label: "Report details" },
      { id: "illness-history", label: "History of Present Illness" },
      { id: "assessment-plan", label: "Assessment and Plan" },
      { id: "review-of-systems", label: "Review of Systems" },
      { id: "vitals", label: "Vitals" },
      { id: "physical-exam", label: "Physical Exam" },
    ],
    [],
  );

  React.useEffect(() => {
    if (!setIsStretchContent) {
      return;
    }

    setIsStretchContent(true);

    return () => {
      setIsStretchContent(false);
    };
  }, [setIsStretchContent]);

  return (
    <Styled.Container>
      <Styled.BackBtn onClick={() => navigate(-1)}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.50062 14.1674L3.33398 10.0006L7.50065 5.83398"
            stroke="#181818"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33398 10H16.6673"
            stroke="#181818"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Back
      </Styled.BackBtn>
      <Styled.PageHeader>
        <Styled.Title>History & Physical Report</Styled.Title>
        <Styled.Download>
          <div>Download All</div>
          <Styled.DownloadOptions>
            <a href="#" download="documents.csv">
              <svg
                width="38"
                height="38"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="38" height="38" rx="6" fill="#F8F8F8" />
                <path
                  d="M11 19.9998V11.002C11 9.89651 11.8968 9.00072 13.0022 9.00195L19.9958 9.00973L27 15.9998V19.9998M20 9.49975V13.9998C20 15.1043 20.8954 15.9998 22 15.9998H26.5"
                  stroke="#181818"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M20 23H18C17.4477 23 17 23.4477 17 24V25C17 25.5523 17.4477 26 18 26H19C19.5523 26 20 26.4477 20 27V28C20 28.5523 19.5523 29 19 29H17M22.5 23L24.75 29L27 23M14.5 28C14.5 28.5523 14.0523 29 13.5 29H12C11.4477 29 11 28.5523 11 28V24C11 23.4477 11.4477 23 12 23H13.5C14.0523 23 14.5 23.4477 14.5 24"
                  stroke="#181818"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a href="#" download="documents.xlsx">
              <svg
                width="38"
                height="38"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="38" height="38" rx="6" fill="#F8F8F8" />
                <path
                  d="M17.5 23V29H21"
                  stroke="#181818"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11 23L13 26M13 26L15 29M13 26L15 23M13 26L11 29"
                  stroke="#181818"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M27.0002 23H23.5V26H27.0002V29H23.5"
                  stroke="#181818"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11 19.9978L11.0199 10.9956C11.0224 9.89186 11.9184 8.99877 13.0222 9L19.9958 9.00776L27 15.9948L26.9922 19.9978M20 9.49778V13.9978C20 15.1024 20.8954 15.9978 22 15.9978H26.5"
                  stroke="#181818"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a href="#" download="documents.pdf">
              <svg
                width="38"
                height="38"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="38" height="38" rx="6" fill="#F8F8F8" />
                <path
                  d="M11 19.9978L11.0199 10.9956C11.0224 9.89186 11.9185 8.99877 13.0222 9L19.9958 9.00776L27 15.9948L26.9922 19.9978M20 9.49778V13.9978C20 15.1024 20.8954 15.9978 22 15.9978H26.5"
                  stroke="#181818"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M26.5 23.75C26.9142 23.75 27.25 23.4142 27.25 23C27.25 22.5858 26.9142 22.25 26.5 22.25V23.75ZM23 23V22.25C22.5858 22.25 22.25 22.5858 22.25 23H23ZM22.25 29C22.25 29.4142 22.5858 29.75 23 29.75C23.4142 29.75 23.75 29.4142 23.75 29H22.25ZM26 26.75C26.4142 26.75 26.75 26.4142 26.75 26C26.75 25.5858 26.4142 25.25 26 25.25V26.75ZM11 23V22.25C10.5858 22.25 10.25 22.5858 10.25 23H11ZM10.25 29C10.25 29.4142 10.5858 29.75 11 29.75C11.4142 29.75 11.75 29.4142 11.75 29H10.25ZM17 23V22.25C16.5858 22.25 16.25 22.5858 16.25 23H17ZM17 29H16.25C16.25 29.4142 16.5858 29.75 17 29.75V29ZM26.5 22.25H23V23.75H26.5V22.25ZM22.25 23V26H23.75V23H22.25ZM22.25 26V29H23.75V26H22.25ZM23 26.75H26V25.25H23V26.75ZM11 23.75H12.75V22.25H11V23.75ZM11.75 29V26.5H10.25V29H11.75ZM11.75 26.5V23H10.25V26.5H11.75ZM12.75 25.75H11V27.25H12.75V25.75ZM13.75 24.75C13.75 25.3023 13.3023 25.75 12.75 25.75V27.25C14.1307 27.25 15.25 26.1307 15.25 24.75H13.75ZM12.75 23.75C13.3023 23.75 13.75 24.1977 13.75 24.75H15.25C15.25 23.3693 14.1307 22.25 12.75 22.25V23.75ZM17 23.75H18.5V22.25H17V23.75ZM19.75 25V27H21.25V25H19.75ZM18.5 28.25H17V29.75H18.5V28.25ZM17.75 29V23H16.25V29H17.75ZM19.75 27C19.75 27.6904 19.1904 28.25 18.5 28.25V29.75C20.0188 29.75 21.25 28.5188 21.25 27H19.75ZM18.5 23.75C19.1904 23.75 19.75 24.3096 19.75 25H21.25C21.25 23.4812 20.0188 22.25 18.5 22.25V23.75Z"
                  fill="#181818"
                />
              </svg>
            </a>
          </Styled.DownloadOptions>
        </Styled.Download>
      </Styled.PageHeader>
      <Styled.InnerContainer>
        <SectionSidebarNav
          ariaLabel="History report sections"
          sections={navigationSections}
          scrollContainerRef={contentScrollerRef}
        />
        <Styled.ContentScroller ref={contentScrollerRef}>
          <Styled.EntityContainer>
            <Styled.Entity>
              <Styled.EntityTitle id="report-details">
                Report Details
              </Styled.EntityTitle>
              <Styled.RowedData>
                <Styled.Row>
                  <Styled.Description>Patient Name</Styled.Description>
                  <Styled.Value>
                    {encounterHistoryItem.patientName}
                  </Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Patient Number</Styled.Description>
                  <Styled.Value>
                    {encounterHistoryItem.patientNumber}
                  </Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Date of Birth</Styled.Description>
                  <Styled.Value>
                    {encounterHistoryItem.dateOfBirth}
                  </Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Gender</Styled.Description>
                  <Styled.Value>{encounterHistoryItem.gender}</Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Ethnicity</Styled.Description>
                  <Styled.Value>{encounterHistoryItem.ethnicity}</Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Marital Status</Styled.Description>
                  <Styled.Value>
                    {encounterHistoryItem.maritalStatus}
                  </Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Language</Styled.Description>
                  <Styled.Value>{encounterHistoryItem.language}</Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Encounter Time</Styled.Description>
                  <Styled.Value>
                    {encounterHistoryItem.encounterTime}
                  </Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Encounter Location</Styled.Description>
                  <Styled.Value>
                    {encounterHistoryItem.encounterLocation}
                  </Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Provider</Styled.Description>
                  <Styled.Value>{encounterHistoryItem.provider}</Styled.Value>
                </Styled.Row>
                <Styled.Row>
                  <Styled.Description>Stats</Styled.Description>
                  <Styled.Value>{encounterHistoryItem.stats}</Styled.Value>
                </Styled.Row>
              </Styled.RowedData>
            </Styled.Entity>
            <Styled.Entity>
              <Styled.EntityTitle id="illness-history">
                History of Present Illness
              </Styled.EntityTitle>
              <Styled.RowedData>
                <Styled.Row>
                  <Styled.DescriptionFull>
                    The patient IS a 25 year old Female who presents with back
                    pain.
                  </Styled.DescriptionFull>
                </Styled.Row>
                <Styled.Row>
                  <Styled.DescriptionFull>
                    The etiology is undetermined. Past treatment has included
                    nonsteroidal anti-inflammatory drugs. Past procedures have
                    included epidural injection. Symptoms include back pain,
                    back stiffness, decreased spine range of motion, decreased
                    flexion, decreased extension, decreased lateral bending and
                    decreased rotation, while symptoms do not include lower
                    extremity numbness, lower extremity tingling or lower
                    extremity weakness. Pain scores include a current pain level
                    of 5 /10. Onset was 2 day(s) ago. The pain is intermittent.
                    The patient describes symptoms as unchanged. Associated
                    symptoms do not include headache, neck pain, dizziness,
                    difficulty walking, difficulty sleeping, urinary
                    incontinence or fecal incontinence.
                  </Styled.DescriptionFull>
                </Styled.Row>
              </Styled.RowedData>
            </Styled.Entity>
            <SingleDataTable healthEntity={encounterHistoryItem.healthEntity} />
          </Styled.EntityContainer>
        </Styled.ContentScroller>
      </Styled.InnerContainer>
    </Styled.Container>
  );
};
